import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { PROOF_WALL_MIN } from "@/components/ListenerStories";

const LAST_KEY = "umbra_pricing_quote_idx";

function pick(n) {
  let last = -1;
  try { last = Number(window.localStorage.getItem(LAST_KEY) ?? -1); } catch { /* storage off */ }
  let i = Math.floor(Math.random() * n);
  if (n > 1 && i === last) i = (i + 1) % n;
  try { window.localStorage.setItem(LAST_KEY, String(i)); } catch { /* storage off */ }
  return i;
}

// One published listener quote above the plans; a different one each visit. Hidden below 3 stories.
export default function PricingQuote() {
  const [story, setStory] = useState(null);
  const idx = useRef(null);

  useEffect(() => {
    api.get("/listener-stories").then((r) => {
      const s = r.data.stories || [];
      if (s.length < PROOF_WALL_MIN) return;
      if (idx.current === null) idx.current = pick(s.length);
      setStory(s[idx.current % s.length]);
    }).catch(() => {});
  }, []);

  if (!story) return null;
  return (
    <figure className="mt-10 max-w-2xl border-l-2 border-terracotta pl-5 sm:pl-6 py-1 animate-fade-up" data-testid="pricing-listener-quote">
      <blockquote className="font-serif italic text-lg sm:text-xl text-bone-200 leading-relaxed" data-testid="pricing-listener-quote-text">
        &ldquo;{story.quote}&rdquo;
      </blockquote>
      <figcaption className="mt-3 font-sans text-[0.65rem] uppercase tracking-[0.24em] text-bone-500" data-testid="pricing-listener-quote-name">
        — {story.first_name}
        {story.number ? <span className="whitespace-nowrap"> · Listener №{story.number}</span> : ""}
      </figcaption>
    </figure>
  );
}
